import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=0fe5f463&scoped=true&"
import script from "./MiPerfil.vue?vue&type=script&lang=js&"
export * from "./MiPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=0fe5f463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe5f463",
  null
  
)

export default component.exports